'use strict';

define('PreferencesFac',[
    'PreferencesEntityBuilder',
    'lodash'
], function (PreferencesEntityBuilder, _) {
    function PreferencesFac($http, $q, $rootScope, ConfigurationFac) {
        var baseUrl = ConfigurationFac.getServiceApiUrl('uam');
        var preferencesStore;
        var userId;

        function _readUserId() {
            userId = $rootScope.user ? $rootScope.user.accountNumber : false;
        }

        function isPreferenceObject (pref) {
            return _.isObject(pref) && pref.hasOwnProperty('metadata') && pref.hasOwnProperty('description');
        }

        function _buildPreferenceList(preferences){
            var userPreferences = [];
            if (_.isArray(preferences)) {
                userPreferences = preferences.map(function(preference) {
                    return PreferencesEntityBuilder()
                        .withMetadata(preference.metadata)
                        .withDescription(preference.description)
                        .build();
                });
            }

            if (isPreferenceObject(preferences)) {
                userPreferences.push(preferences);
            }

            return userPreferences;
        }

        var preferencesFac =  {
            // returns preferences in legacy format
            getUserPreferences: function(forceFetch) {
                var deferred = $q.defer();

                if(preferencesStore && !forceFetch) {
                    deferred.resolve(preferencesStore);
                } else {
                    preferencesStore = [];
                    this.getPreferences().then(function(preferenceData) {
                        _.map(preferenceData, function(pref) {
                            var value = pref.metadata;
                            switch(pref.description) {
                                case 'balance_is_shown':
                                case 'show_bet_confirm':
                                case 'bet_type': {
                                    value = parseInt(pref.metadata);
                                    break;
                                }
                                case 'bet_prefs': {
                                    if($rootScope.activeFeatures.usePrefReact) {
                                        value = JSON.parse(pref.metadata);
                                    } else {
                                        value = {
                                            defaultBetType: "10",
                                            default_bet_amount:{
                                                10: "0.00",
                                                20: "0.00",
                                                30: "0.00",
                                                110: "0.00",
                                                160: "0.00",
                                                210: "0.00",
                                                260: "0.00",
                                                "P": "0.00"
                                            },
                                            useCustomBetAmount: false,
                                            useMinimumBetAmount: true
                                        };
                                    }
                                    break;
                                }
                            }
                            preferencesStore[pref.description] = value;
                        });

                        $rootScope.$broadcast('preferencesReady', preferencesStore);

                        deferred.resolve(preferencesStore);
                    }, function(response) {
                        deferred.reject(response.error);
                    });
                }

                return deferred.promise;
            },
            getPreferences: function() {
                var deferred = $q.defer();

                _readUserId();
                if(!userId) {
                    deferred.reject('Could not obtain user id');
                } else {
                    var url = baseUrl + '/users/' + userId + '/preferences';

                    $http.get(url).success(function (response) {
                        deferred.resolve(_buildPreferenceList((response.preferences)));
                    }).error(function (response) {
                        deferred.reject(response.error);
                    });
                }

                return deferred.promise;
            },
            getUniquePreference: function(preferenceName) {
                var deferred = $q.defer();
                var url = baseUrl;

                if(preferenceName === 'FAVORITE_TRACKS') {
                    url += '/preferences?preferenceName=' + preferenceName;
                } else {
                    _readUserId();
                    if(!userId) {
                        deferred.reject('Could not obtain user id');
                        return deferred.promise;
                    }

                    url += baseUrl + '/users/' + userId + '/preferences/' + preferenceName;
                }

                $http.get(url).success(function (response) {
                    if (_.isArray(response.preferences) && response.preferences.length)
                    {
                       var preference = PreferencesEntityBuilder()
                           .withMetadata(response.preferences[0].metadata)
                           .withDescription(response.preferences[0].description)
                           .build();

                        deferred.resolve(preference);
                    } else {
                        deferred.reject('Invalid Data');
                    }
                }).error(function () {
                    var defaultPrefs = {
                        description: 'FAVORITE_TRACKS',
                        metadata: ''
                    };
                    deferred.resolve(defaultPrefs);
                });

                return deferred.promise;
            },
            updatePreferences: function(preferences) {
                var deferred = $q.defer();

                _readUserId();
                if(!userId) {
                    deferred.reject('Could not obtain user id');
                } else {
                    var prefList = _buildPreferenceList(preferences);
                    var url = baseUrl + '/users/' + userId + '/preferences';

                    $http.put(url, {
                        preferences: prefList
                    }).success(function (response) {
                        deferred.resolve(response);
                    }).error(function (response) {
                        deferred.reject(response.error);
                    });
                }

                return deferred.promise;
            }
        };

        return {
            getPreferences: preferencesFac.getPreferences,
            getUniquePreference: preferencesFac.getUniquePreference,
            updatePreferences: preferencesFac.updatePreferences,
            getUserPreferences: preferencesFac.getUserPreferences
        };
    }

    PreferencesFac.$inject = [
        '$http',
        '$q',
        '$rootScope',
        'ConfigurationFac'
    ];

    return PreferencesFac;

});

